import { client } from '@/util/base'
;(function (win, doc) {
  if (!win.addEventListener) return
  function setFont() {
    var html = document.documentElement
    var k = ''
    if (client() === '2') {
      k = 750
    } else {
      k = 1920
    }
    html.style.fontSize = (html.clientWidth / k) * 100 + 'px'
  }
  doc.addEventListener('DOMContentLoaded', setFont, false)
  win.addEventListener('resize', setFont, false)
  win.addEventListener('load', setFont, false)
})(window, document)
